import { Patient } from "../../patient";
import { PatientAddress } from "../items";
import { HisInformation } from "../../his";

// 患者
export class ReceptionPatient {
  public patient: Patient;
  public patientNote: string;
  public patientNoteBeforeEditing: string;
  public address: PatientAddress;
  public hisInformation: HisInformation;

  clone(): ReceptionPatient {
    const newObj = new ReceptionPatient();
    newObj.patient = this.patient;
    newObj.patientNote = this.patientNote;
    newObj.patientNoteBeforeEditing = this.patientNoteBeforeEditing;
    newObj.address = this.address;
    newObj.hisInformation = this.hisInformation;

    return newObj;
  }
}
